import { useLingui } from '@lingui/react';
import { useAppConfiguration } from '@wkda/funnel-components';
import { notEmpty } from '../../helpers/isEmpty';
const MIN_MILEAGE = 0;
const MAX_MILEAGE = 999999999;
export const useMinimumMileageValidation = () => {
  const {
    i18n
  } = useLingui();
  // @ts-ignore
  const {
    minimumMileage
  } = useAppConfiguration();
  return {
    createCustomValidators: [function mileageValidator({
      validators
    }) {
      return {
        ...validators,
        mileage({
          value,
          errorMessages,
          values
        }) {
          const {
            builtDate
          } = values;
          if (minimumMileage && isMileageInvalidForYear(builtDate, value)) {
            return i18n._('carleadCreation.error.minimumMileage');
          }
          if (mileageIsOutOfBounds(value)) {
            return errorMessages.tooLongMileage;
          }
          return notEmpty(value) && Number(value) > MIN_MILEAGE && Number(value) <= MAX_MILEAGE || errorMessages.mileage;
        }
      };
    }]
  };
};
function mileageIsOutOfBounds(mileage = '') {
  return notEmpty(mileage) && Number(mileage) > MAX_MILEAGE;
}
function isMileageInvalidForYear(builtDate = '', mileage = '') {
  const currentYear = new Date().getFullYear();
  const builtYear = parseInt(builtDate, 10);
  return builtYear < currentYear - 1 && parseInt(mileage, 10) < 1000;
}